import { CreateCampaignsComponent } from "./create-campaigns/create-campaigns.component";
import { EditCampaignsComponent } from "./edit-campaigns/edit-campaigns.component";
import { ListCampaignsComponent } from "./list-campaigns/list-campaigns.component";

export const CampaignsRouting = [
    { path: '', redirectTo: 'view-campaigns', pathMatch: 'full' },
    { path: 'create-campaigns', component: CreateCampaignsComponent },
    { path: 'edit-campaigns', component: EditCampaignsComponent },
    { path: 'view-campaigns', component: ListCampaignsComponent },

];

export const CampaignsRoutingBreadcrumbs = [

    { name: 'View', path: '/view-campaigns' },
    { name: 'Create', path: '/create-campaigns'},
    { name: 'Edit',  path:'/edit-campaigns'},
  
];